export default __webpack_public_path__ + "static/media/background.9be54f4a.svg";